import { render, staticRenderFns } from "./DailyChatHeader.vue?vue&type=template&id=5fc9c09e&scoped=true"
import script from "./DailyChatHeader.vue?vue&type=script&lang=js"
export * from "./DailyChatHeader.vue?vue&type=script&lang=js"
import style0 from "./DailyChatHeader.vue?vue&type=style&index=0&id=5fc9c09e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc9c09e",
  null
  
)

export default component.exports